import React from 'react'

function NonTransport() {
  return (
    <div>
      <h4 className='text-main mt-5 text-center w-75 mx-auto'>
        You are currently not an approved Transport shopper. If you are interested in being considered for mystery shopping tasks involving buses, ferries, and wharves - and are either based in Sydney or travel there at least once a month - please express your interest by emailing:<a href='mailto:shoppers@mysterymanagement.com.au'>shoppers@mysterymanagement.com.au</a>.
      </h4>
    </div>
  )
}

export default NonTransport
